import React from "react";
import { Card, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { H1, SecondaryButton, useGet } from "@collabodoc/component-library";
import { API_URLS, VIEWS } from "../../URLS";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import StatusTemplate from "./StatusTemplate";
import SubStatusTemplate from "./SubStatusTemplate";

const IconButton = styled(SecondaryButton)`
  svg:first-child {
    margin-right: 5px;
  }
`;

const PageHeader = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
const getChildIds = (itemTemplate) => {
  const ids = [];
  if (itemTemplate) {
    ids.push(itemTemplate.statusTemplateId);
    itemTemplate.childStatusTemplates.forEach((childItem) => {
      ids.push(...getChildIds(childItem));
    });
  }
  return ids;
};

const StatusTemplateView = () => {
  const { accessToken } = useOidcAccessToken();
  const navigate = useNavigate();
  const { itemId } = useParams();
  const { response: itemTemplateGroup = [], doGet: reFetchItem } = useGet(
    API_URLS.STATUSWITHFAMILY(itemId),
    accessToken,
    true,
    { "cache-control": "no-cache" }
  );

  return (
    <>
      {itemTemplateGroup.length ? (
        <>
          <PageHeader>
            <IconButton type="button" onClick={() => navigate(VIEWS.STATUSTEMPLATES)}>
              <FontAwesomeIcon icon={faAngleLeft} />
              <span>Till statuslista</span>
            </IconButton>
            <H1>{itemTemplateGroup[0].groupTitle}</H1>
            <p></p>
          </PageHeader>
          {itemTemplateGroup.map((ig, index) => (
            <ItemTemplateGroup
              group={ig}
              key={index}
              reFetchItem={reFetchItem}
            />
          ))}
        </>
      ) : (
        <Col lg={{ span: 4 }}>
          <Card>
            <Card.Header>Det finns ingen status med id {itemId}</Card.Header>
          </Card>
        </Col>
      )}
    </>
  );
};

export default StatusTemplateView;

const ItemTemplateGroup = ({ group, reFetchItem }) => {
  const familyIds = getChildIds(group);
  return (
    <>
      <StatusTemplate
        item={group}
        familyIds={familyIds}
        level={0}
        reFetchItem={reFetchItem}
        isChildItem={group.parentStatusTemplateId !== null}
      />
      {group.childStatusTemplates.map((item) => (
        <SubStatusTemplate
          key={Math.random()}
          item={item}
          familyIds={familyIds}
          reFetchItem={reFetchItem}
          level={1}
        />
      ))}
    </>
  );
};
